import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { Box, Button, SubHeading } from '@components/common';
import { MobileContainer, DesktopContainer } from '@containers/layout';
import DiscontinueCalendarBoard from './DiscontinueCalendarBoard';
import { DiscontinueSelectors } from '@redux/DiscontinueRedux';
import history from '@utils/history';

const DesktopWrapper = styled(DesktopContainer)`
  @media screen and (min-width: 1024px) {
    padding-top: 0;
  }
  @media screen and (min-width: 768px) and (max-width: 1023px) {
    padding-top: 0;
  }
  @media screen and (max-width: 767px) {
    flex-direction: column-reverse;
    justify-content: flex-end;
  }
`;

const ContainerView = styled(MobileContainer)`
  align-self: flex-start;
  align-items: stretch;
  z-index: 100;
  @media screen and (max-width: 767px) {
    flex: 0;
  }
  @media screen and (min-width: 1024px) {
    padding-top: 0px;
  }
`;

const MobileOnly = styled(Box)`
  width: 100%;
  @media screen and (min-width: 1024px) {
    display: none;
  }
  @media screen and (min-width: 768px) and (max-width: 1023px) {
    display: none;
  }
  @media screen and (max-width: 767px) {
    display: block;
  }
`;

const DesktopOnly = styled(Box)`
  width: 100%;
  @media screen and (max-width: 767px) {
    display: none;
  }
  @media screen and (min-width: 768px) and (max-width: 1023px) {
    display: block;
  }
  @media screen and (min-width: 1024px) {
    display: block;
  }
`;

function DiscontinueDate(props) {
  const { onSubmit, onCancel, discontinueDate, isPause } = props;
  const isDisabled = !discontinueDate;

  return (
    <DesktopWrapper>
      <MobileOnly>
        <Button
          my={2}
          width={1}
          type="button"
          onClick={onSubmit}
          disabled={isDisabled}
        >
          Continue
        </Button>
      </MobileOnly>
      <DiscontinueCalendarBoard flex={1} />
      <ContainerView>
        <Box position="relative">
          <SubHeading px={2} mb={1} fontSize={2}>
            {isPause
              ? 'Select the week when you would like to resume your schedule'
              : 'Choose your service end date.'}
          </SubHeading>
          <DesktopOnly>
            <Button
              my={2}
              width={1}
              type="button"
              onClick={() => {
                history.goBack();
              }}
            >
              Cancel
            </Button>
            <Button
              my={2}
              width={1}
              type="button"
              onClick={onSubmit}
              disabled={isDisabled}
            >
              Continue
            </Button>
          </DesktopOnly>
        </Box>
      </ContainerView>
    </DesktopWrapper>
  );
}

DiscontinueDate.propTypes = {
  onCancel: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  discontinueDate: PropTypes.object,
  isPause: PropTypes.bool
};

const mapStatesToProps = state => ({
  discontinueDate: DiscontinueSelectors.selectDiscontinueDate(state),
  isPause: DiscontinueSelectors.selectIsPause(state)
});

export default connect(mapStatesToProps)(DiscontinueDate);
